import { Backdrop, Button, Modal, makeStyles } from '@material-ui/core';
import { height } from '@material-ui/system';
import React, { useEffect, useState, memo } from 'react';
import Carousel from '../Carousel';
import '../../styles/pdfPopup.css';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.1)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    position: 'absolute!important',
    width: '260px',
    minHeight: '100px',
    maxHeight: '130px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: '260px',
    backgroundColor: 'transparent',
    boxShadow: theme.shadows[5]
    // padding: theme.spacing(2, 4, 3)
  },
  transparentBackdrop: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent' // Adjust the alpha value for transparency
  }
}));

const CommentModal = ({
  open,
  flagData,
  onClose,
  popupPosition,
  handleFlagPlay,
  handleConfirmationDeleteOpen,
  handleShareModalInit,
  instance,
  isPersonalPodcast
}) => {
  const classes = useStyles();
  const [dataForPopUp, setDataForPopUp] = useState([]);

  const modifiedData = () => {
    const myData = flagData?.customData;
    setDataForPopUp(myData);
  };

  const closePopUp = () => {
    onClose();
  };

  useEffect(() => {
    modifiedData();
  }, [flagData]);

  if (!open) {
    return null;
  }
  return (
    <Modal
      disablePortal={true}
      onMouseLeave={(e) => {
        e.preventDefault();
        onClose();
      }}
      className={classes.modal}
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{ top: popupPosition.top + 80, left: popupPosition.left - 20 }}
      BackdropComponent={(props) => (
        <Backdrop {...props} className={classes.transparentBackdrop} />
      )}
    >
      {open && (
        <div className="dropbtn" style={{ width: '100%' }}>
          <Carousel
            key={flagData?.id}
            data={dataForPopUp}
            instance={instance}
            onClose={closePopUp}
            handleFlagPlay={handleFlagPlay}
            handleConfirmationDeleteOpen={handleConfirmationDeleteOpen}
            handleShareModalInit={handleShareModalInit}
            isPersonalPodcast={isPersonalPodcast}
          />
        </div>
      )}
    </Modal>
  );
};

export default memo(CommentModal);
